(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/store/redux.js');
"use strict";


const _svs$termsIntegrity$s = svs.termsIntegrity.store,
  reducer = _svs$termsIntegrity$s.reducer,
  initialState = _svs$termsIntegrity$s.initialState;
const combinedReducers = RTK.combineReducers({
  termsIntegrity: reducer
});
svs.termsIntegrity.store.createStore = initialState => RTK.createStore(combinedReducers, initialState);
const store = svs.termsIntegrity.store.createStore({
  termsIntegrity: initialState
});
const TermsIntegrityReduxProvider = _ref => {
  let children = _ref.children;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.termsIntegrity.store.TermsIntegrityReduxProvider = TermsIntegrityReduxProvider;

 })(window);